import { useState } from 'react';
import UpgradeModal from './UpgradeModal';

/**
 * Proactive quota indicator shown near rate-limited feature inputs.
 *
 * Stub in Phase A — basic rendering only.  Will be wired to real quota
 * data from API responses in Phase B.
 *
 * Rendering rules:
 * - Hidden entirely when quota.unlimited === true
 * - Visible with count when metered
 * - Clickable "Upgrade for more" link opens UpgradeModal
 *
 * @param {Object} props
 * @param {Object} [props.quota] - { remaining, total, unlimited }
 * @param {string} [props.feature] - feature key for upgrade modal
 * @param {"pro"|"premium"} [props.suggestedTier]
 */
export default function QuotaDisplay({ quota, feature, suggestedTier = 'pro' }) {
  const [modalOpen, setModalOpen] = useState(false);

  if (!quota || quota.unlimited) return null;

  return (
    <>
      <div className="flex items-center gap-1.5 text-[12px] text-[#6b7280] dark:text-[#64748b]">
        <span>
          {quota.remaining} of {quota.total} remaining today
        </span>
        <span>·</span>
        <button
          onClick={() => setModalOpen(true)}
          className="text-[#005BB3] hover:underline"
        >
          Upgrade for more
        </button>
      </div>

      <UpgradeModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        suggestedTier={suggestedTier}
        triggerFeature={feature}
      />
    </>
  );
}
